import { render, staticRenderFns } from "./CategoryModal.vue?vue&type=template&id=a428ada2&scoped=true&"
import script from "./CategoryModal.vue?vue&type=script&lang=js&"
export * from "./CategoryModal.vue?vue&type=script&lang=js&"
import style0 from "./CategoryModal.vue?vue&type=style&index=0&id=a428ada2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a428ada2",
  null
  
)

export default component.exports